/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class OpsiAddChatContactDialog extends Serenity.TemplatedDialog<AddContactDialogOptions> {
        public callbackNew = (response) => {

        }
        constructor(opt: AddContactDialogOptions) {
            super(opt);
            var $this = this;
            this.dialogTitle = "Add link to contact";
            var button1 = $(`<button class="btn btn-primary mt-3 mx-8 w-100" style="margin-top:0px !important;"><i class="fa fa-user-plus text-blue"></i> Create new contact</button>`);
            button1.on("click", () => {
                var dlg = new Nobox.LeadDialog();
                dlg.callback = (res) => {
                    $this.dialogClose();
                    this.callbackNew(res);
                }
                dlg.loadEntityAndOpenDialog({ LinkId: this.options.ID });
                //dlg.IdLink = this.options.ID;
                //dlg.dialogOpen();
            });
            var button2 = $(`<button class="btn btn-primary mt-3 mx-8 w-100"><i class="fa fa-user text-blue"></i> Add to existing contact</button>`);
            button2.on("click", () => {
                var dlg = new Nobox.SelectLinkRoomDialog();
                dlg.callback = (res) => {
                    $this.dialogClose();
                    this.callbackNew(res);
                }
                dlg.IdLink = this.options.ID;
                dlg.dialogOpen();
            });
            var button3 = $("<div></div>").append(button1, button2);
            this.byId('DialogPicker').append(button3);
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [];
        }

        protected getTemplate() {
            return "<div id='~_DialogPicker'></div>";
        }
    }
    export interface AddContactDialogOptions {
        ID: number;
        //leadsGrid: ListLeadGrid;
    }
}